// extracted by mini-css-extract-plugin
export default {"dialog":"Dialog_dialog__IL2mM","MuiPaper-root":"Dialog_MuiPaper-root__0-2Gz"};